import React, { useEffect, useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import HSAxios from "../HSAxios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "../index.css";
import { BiBorderBottom } from "react-icons/bi";
import { FaExclamationCircle } from "react-icons/fa";
import { Col, Row } from "react-bootstrap";
import { useLocation } from "react-router-dom";
import PaymentStatusModal from "./PaymentStatusModal";
import MapComponent from "./MapComponent";
import { Modal } from "react-bootstrap";
import { Map, AdvancedMarker, APIProvider } from "@vis.gl/react-google-maps";
import useNotification from "../CustomHook/useNotification";

const steps = ["Basic", "Features", "Location", "Price", "Preview"];

const DEFAULT_POSITION = { lat: 28.6139, lng: 77.209 };

export default function Adminform() {
  const location = useLocation();
  const data = location.state;
  const notify = useNotification();
  console.log(data);
  const [btnLoading, setBtnLoading] = useState(false);
  const [preview, setPreview] = useState(false);
  const [room1, setRoom1] = useState("");
  const [room2, setRoom2] = useState("");
  const [room3, setRoom3] = useState("");
  const [status, setStatus] = useState(null);
  const [position, setPosition] = useState({ lat: null, lng: null });

  const [show, setShow] = useState(false);
  const [msg, setMsg] = useState("");
  const [title, setTitle] = useState("");
  const [btnTitle, setBtnTitle] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const [roomPhotos, setRoomPhotos] = useState([]);
  const [commonRoomPhotos, setCommonRoomPhotos] = useState([]);
  const [hostelPhotos, setHostelPhotos] = useState([]);
  const [uploadStatus, setUploadStatus] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [errors, setErrors] = useState({});
  const [roomUploadStatus, setRoomUploadStatus] = useState("");
  const [roomUploadProgress, setRoomUploadProgress] = useState(0);

  // Separate state for Common Room Photos
  const [commonRoomUploadStatus, setCommonRoomUploadStatus] = useState("");
  const [commonRoomUploadProgress, setCommonRoomUploadProgress] = useState(0);

  // Separate state for Hostel Photos
  const [hostelUploadStatus, setHostelUploadStatus] = useState("");
  const [hostelUploadProgress, setHostelUploadProgress] = useState(0);

  // location permission functions **********************************************************

  const [showPermissionModal, setShowPermissionModal] = useState(false);

  const isInAndroidWebView = () => {
    // const ua = navigator.userAgent || "";
    // return /wv|Android/i.test(ua) && window.ReactNativeWebView !== undefined;

    const ua = navigator.userAgent || "";

    // Detect React Native WebView by injected object
    const isReactNative = typeof window.ReactNativeWebView !== "undefined";

    // Also detect Android WebView by "wv" or "Version/x.x Chrome/x.x" format
    const isAndroidWebView =
      /; wv/.test(ua) || /\bVersion\/[\d.]+.*Chrome/.test(ua);

    return isReactNative || isAndroidWebView;
  };

  const getGeolocation = () => {
    if (!navigator.geolocation) {
      notify("Geolocation not supported by your browser.", "danger");
      // setPosition(DEFAULT_POSITION);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const coords = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
        };
        setPosition(coords);
        setShowPermissionModal(false);
      },
      (err) => {
        console.warn("Geolocation error:", err.message);
        notify("Location access denied or unavailable.", "danger");
        // setPosition(DEFAULT_POSITION);
        setShowPermissionModal(true);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  };

  const checkPermissionAndRequest = async () => {
    try {
      const permissionStatus = await navigator.permissions.query({
        name: "geolocation",
      });

      if (permissionStatus.state === "granted") {
        getGeolocation();
      } else if (
        permissionStatus.state === "prompt" ||
        permissionStatus.state === "denied"
      ) {
        // Try to request location
        getGeolocation();
      }

      // Listen to permission changes (in supported browsers)
      permissionStatus.onchange = () => {
        if (permissionStatus.state === "granted") {
          getGeolocation();
        }
      };
    } catch (error) {
      // Permissions API may not be supported (fallback to try)
      getGeolocation();
    }
  };

  useEffect(() => {
    checkPermissionAndRequest();
  }, []);

  // location permission ended

  const [error, setError] = useState({
    room_photo: "",
    common_room_photo: "",
    hostel_photo: "",
  });
  const validateFiles = () => {
    const newErrors = {};

    if (!room1) {
      newErrors.room_photo = "Room photo is required.";
    }
    if (!room2) {
      newErrors.common_room_photo = "Common room photo is required.";
    }
    if (!room3) {
      newErrors.hostel_photo = "Hostel photo is required.";
    }

    setError(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // useEffect(() => {
  //   navigator.geolocation.getCurrentPosition((location) => {
  //     setPosition({
  //       lat: location.coords.latitude,
  //       lng: location.coords.longitude,
  //     });
  //   });
  // }, []);

  useEffect(() => {
    const token = Cookies.get("token");
    console.log("check");

    if (!token) {
      console.log("Not logged in");
      navigate("/login", {});

      return;
    }
  });

  useEffect(() => {
    if (data) {
      setPreview(data.preview);
    }
  });

  const [formData, setFormData] = useState({
    name: "", // hostelName
    address: "", // hostelAddress
    pincode: "", // hostelPincode
    food: "", // hostelFood
    wifi: "", // hostelWifi
    housekeeping: "", // hostelHousekepping
    gender: "", // hostelGender
    purified_water: "", // hostelWater
    workout_zone: "", // wworkoutZone
    refrigerator: "", // hostelRefrigerator
    hot_water_supply: "", // hostelHotWater
    washroom: "", // hostelWashroom
    room_type: "", // hostelRoomType
    unit: "", // hosteUnit
    starting_price: "", // hostelPrice
    room_photo: "", // roomPhoto
    attached_room_photo: "", // attachedRoomPhoto
    common_room_photo: "", // commonRoomPhoto
    hostel_id: null,
    // lat:null,
    // long:null,
  });
  // managing the current progress of form
  const [currentStep, setCurrentStep] = useState(0);
  // preview state

  const navigate = useNavigate();

  const validateFields = () => {
    const validationErrors = {};
    if (currentStep === 0) {
      if (!formData.name) validationErrors.name = "Name is required!";
      if (!formData.address) validationErrors.address = "Address is required!";
      if (!formData.pincode) validationErrors.pincode = "Pincode is required!";

      if (!formData.gender) validationErrors.gender = "Gender is required!";
      if (!formData.room_type)
        validationErrors.room_type = "Room type is required";
    } else if (currentStep === 1) {
      if (!formData.food) validationErrors.food = "Food is required!";
      if (!formData.wifi) validationErrors.wifi = "Wifi is required!";
      if (!formData.housekeeping)
        validationErrors.housekeeping = "House Keeping is required!";
      if (!formData.purified_water)
        validationErrors.purified_water = "Purified Water is required!";
      if (!formData.workout_zone)
        validationErrors.workout_zone = "Workout Zone is required!";
      if (!formData.refrigerator)
        validationErrors.refrigerator = "Referigerator is required!";
      if (!formData.hot_water_supply)
        validationErrors.hot_water_supply = "Hot water supply is required!";

      if (!formData.washroom)
        validationErrors.washroom = "Washroom is required!";
    } else if (currentStep === 3) {
      if (!formData.starting_price || formData.starting_price <= 0)
        validationErrors.starting_price =
          "Starting price must be greater than 0!";
      if (!formData.unit) validationErrors.unit = "Unit is required!";
    }

    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };

  const handleRoomType = (event) => {
    const value = event.target.value;
    let updatedRoomTypes = formData.room_type.split(",").filter(Boolean);

    if (event.target.checked) {
      updatedRoomTypes.push(value);
    } else {
      updatedRoomTypes = updatedRoomTypes.filter((item) => item !== value);
    }

    setFormData((prev) => ({
      ...prev,
      room_type: updatedRoomTypes.join(","),
    }));
  };

  const handleSubmit = (event) => {
    if (event.key == "Enter") {
      return;
    }
    event.preventDefault();
    setBtnLoading(true);

    let loginUrl = "https://api.hostelduniya.com/api/hostel/add";

    const submissionData = {
      ...formData,
      room_type: formData.room_type,
      lat: position.lat,
      long: position.lng,
    };
    console.log(submissionData);

    HSAxios.post(loginUrl, submissionData)
      .then((response) => {
        if (response.status == 200) {
          setMsg(
            "Hostel Registered Successfully! Redirecting to Hostel List page..."
          );
          setTitle("Registeration Status");
          setIsSuccess(true);
          setShow(true);
          setTimeout(() => navigate("/hostel/list"), 3000);
          // navigate("/hostel/list");
          setFormData((prev) => ({
            ...prev,
            hostel_id: response.hostel_id,
          }));
        }
      })
      .catch((e) => {
        setMsg("Some error occurred! Please try again...");
        setTitle("Registeration Status");
        setIsSuccess(false);
        setShow(true);

        console.error(e);
      })
      .finally(() => {
        setBtnLoading(false);
      });

    console.log("Form submitted successfully!");
  };
  const handleNext = () => {
    if (validateFields()) {
      setCurrentStep((prevStep) => prevStep + 1);
    }
  };
  const handleEdit = () => {
    setCurrentStep(0);
    // setPreview(!preview);
  };

  const handleRoomPhotoChange = (e) => {
    const files = Array.from(e.target.files);
    setRoomPhotos(files);
    console.log(files);
  };

  const handleCommonRoomPhotoChange = (e) => {
    const files = Array.from(e.target.files);
    setCommonRoomPhotos(files);
    console.log(files);
  };

  const handleHostelPhotoChange = (e) => {
    const files = Array.from(e.target.files);
    setHostelPhotos(files);
    console.log(files);
  };

  const handleUploadRoom = async () => {
    const formdata = new FormData();
    roomPhotos.forEach((file) => {
      formdata.append("file", file);
    });
    if (data) {
      formdata.append("hostel_id", data.hostelId);
    }
    formdata.append("image_type", "room");

    try {
      setRoomUploadStatus("Uploading...");

      const response = await HSAxios.post("api/upload", formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 60000,
      });
      console.log(response);

      if (response) {
        setStatus(true);
        setRoomUploadStatus("Upload successful!");
        if (data && data.hostelId) {
          const getData = data.formd;
        }
        setRoom1(response.path);
        console.log(formData);
      } else {
        setStatus(false);
        setRoomUploadStatus("Upload failed. Please try again.");
      }
    } catch (error) {
      console.error(error);
      setStatus(false);

      setRoomUploadStatus("An error occurred during upload.");
    }
  };

  // Upload Common Room Photos
  const handleUploadCommonRoom = async () => {
    const formdata = new FormData();
    commonRoomPhotos.forEach((file) => {
      formdata.append("file", file);
    });
    if (data) {
      formdata.append("hostel_id", data.hostelId);
    }
    formdata.append("image_type", "common_room");

    try {
      setCommonRoomUploadStatus("Uploading common room photos...");
      const response = await HSAxios.post("api/upload", formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 60000,
      });

      if (response) {
        setStatus(true);
        setCommonRoomUploadStatus("Common room upload successful!");
        if (data && data.hostelId) {
          const getData = data.formd;
        }
        setRoom2(response.path);

        console.log(formData);
      } else {
        setStatus(false);

        setCommonRoomUploadStatus("Common room upload failed.");
      }
    } catch (error) {
      console.log(error);
      setStatus(false);

      setCommonRoomUploadStatus("Error uploading common room photos.");
    }
  };

  // Upload Hostel Photos
  const handleUploadHostelPhoto = async () => {
    const formdata = new FormData();
    hostelPhotos.forEach((file) => {
      formdata.append("file", file);
    });
    if (data) {
      formdata.append("hostel_id", data.hostelId);
    }
    formdata.append("image_type", "hostel");

    try {
      setHostelUploadStatus("Uploading hostel photos...");
      const response = await HSAxios.post("api/upload", formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        timeout: 60000,
      });

      if (response) {
        setStatus(true);
        setHostelUploadStatus("Hostel upload successful!");
        if (data && data.hostelId) {
          const getData = data.formd;
        }
        setRoom3(response.path);
      } else {
        setStatus(false);

        setHostelUploadStatus("Hostel upload failed.");
      }
    } catch (error) {
      setStatus(false);

      console.log(error);
      setHostelUploadStatus("Error uploading hostel photos.");
    }
  };

  const handleFinalSubmit = () => {
    let updateUrl = "api/hostel/update";
    setBtnLoading(true);
    if (validateFiles()) {
      HSAxios.put(updateUrl, {
        hostel_id: data.hostelId,
        room_photo: room1,
        common_room_photo: room2,
        attached_room_photo: room3,
      })
        .then((res) => {
          if (res.status === 200) {
            console.log(res);
            console.log("data successfully updated");
            setMsg(
              "Photos Uploaded Successfully! Redirecting to Hostel List page..."
            );
            setTitle("Upload Status");
            setIsSuccess(true);
            setShow(true);
            setTimeout(() => navigate("/hostel/list"), 3000);
          }
        })
        .catch((e) => {
          setMsg("Error occurred while uploading images!");
          setTitle("Upload Status");
          setIsSuccess(false);
          setShow(true);
          console.error(e);
        })
        .finally(() => {
          setBtnLoading(false);
        });
    } else {
      console.log("Validation failed. Check the error messages.");
    }
  };
  const handleBack = () => {
    setCurrentStep((prev) => {
      return currentStep - 1;
    });
  };
  console.log(position);
  return (
    <div className="container mb-3">
      <Modal
        show={showPermissionModal}
        centered
        backdrop="static"
        keyboard={false}
        style={{
          borderRadius: "20px",
        }}
      >
        <Modal.Header
          style={{
            borderBottom: "2px solid #ffc107",
            backgroundColor: "#fffbf0",
            borderRadius: "20px 20px 0 0",
            padding: "20px 25px",
          }}
        >
          <Modal.Title
            style={{
              color: "#856404",
              fontWeight: "700",
              fontSize: "20px",
            }}
          >
            Location Permission Required
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: "30px 25px" }}>
          <div className="text-center">
            <div
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                backgroundColor: "#fff3cd",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px",
                animation: "scaleIn 0.3s ease-out",
              }}
            >
              <FaExclamationCircle
                style={{
                  fontSize: "50px",
                  color: "#ffc107",
                }}
              />
            </div>
            {isInAndroidWebView() ? (
              <div style={{ textAlign: "left" }}>
                <p
                  style={{
                    color: "#856404",
                    fontSize: "15px",
                    lineHeight: "1.6",
                    marginBottom: "15px",
                  }}
                >
                  You're using the Android app. To continue, please:
                </p>
                <div
                  style={{
                    backgroundColor: "#fff3cd",
                    padding: "15px",
                    borderRadius: "10px",
                    marginBottom: "15px",
                  }}
                >
                  <strong style={{ color: "#856404" }}>
                    Go to Settings → Apps → Hostel Duniya Partner → Permissions →
                    Enable Location
                  </strong>
                </div>
                <p
                  style={{
                    color: "#856404",
                    fontSize: "15px",
                    lineHeight: "1.6",
                  }}
                >
                  Then return and click "Retry".
                </p>
              </div>
            ) : (
              <p
                style={{
                  color: "#856404",
                  fontSize: "15px",
                  lineHeight: "1.6",
                }}
              >
                Please allow location access in your browser settings. Look for a
                lock icon in your address bar or open site settings to enable
                Location.
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer
          style={{
            borderTop: "1px solid #e0e0e0",
            padding: "20px 25px",
            borderRadius: "0 0 20px 20px",
          }}
        >
          <Button
            variant="primary"
            onClick={checkPermissionAndRequest}
            className="fw-semibold px-4 py-2"
            style={{
              borderRadius: "10px",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 15px rgba(0, 123, 255, 0.3)",
            }}
            onMouseEnter={(e) => {
              e.target.style.transform = "translateY(-2px)";
              e.target.style.boxShadow = "0 6px 20px rgba(0, 123, 255, 0.4)";
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 4px 15px rgba(0, 123, 255, 0.3)";
            }}
          >
            Retry
          </Button>
        </Modal.Footer>
        <style>
          {`
            @keyframes scaleIn {
              from {
                transform: scale(0);
                opacity: 0;
              }
              to {
                transform: scale(1);
                opacity: 1;
              }
            }
            .modal-content {
              border-radius: 20px !important;
              border: none !important;
              box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2) !important;
            }
            .modal-header .btn-close {
              font-size: 18px;
              opacity: 0.6;
              transition: opacity 0.3s ease;
            }
            .modal-header .btn-close:hover {
              opacity: 1;
            }
          `}
        </style>
      </Modal>
      {preview && (
        <div className="container custom-highlight mt-3">
          <PaymentStatusModal
            msg={msg}
            show={show}
            isSuccess={isSuccess}
            onClose={() => setShow(false)}
            title={title}
            btnTitle={btnTitle}
          />
          <div className="text-center">
            <h5 className="fs-5 fw-bold" style={{ color: "#760B0B" }}>
              UPLOAD HOSTEL IMAGES
            </h5>
          </div>
          <Form.Group
            controlId="roomPhotos"
            className="mb-3 text-black fw-bold text-start"
          >
            <Form.Label>Room Photos</Form.Label>
            <Form.Control
              type="file"
              multiple
              accept=".jpg, .jpeg, .png"
              onChange={handleRoomPhotoChange}
              required
            />
            <button
              className="btn btn-dark mt-2"
              type="button"
              onClick={handleUploadRoom}
            >
              Upload
            </button>

            {roomUploadStatus && (
              <p className={`mt-2 ${status ? "text-success" : "text-danger"}`}>
                {roomUploadStatus}
              </p>
            )}

            {error.room_photo && (
              <p className="text-danger mt-2">{error.room_photo}</p>
            )}
          </Form.Group>

          <Form.Group
            controlId="commonRoomPhotos"
            className="mb-3 text-black fw-bold text-start"
          >
            <Form.Label>Common Room Photos</Form.Label>
            <Form.Control
              type="file"
              multiple
              accept=".jpg, .jpeg, .png"
              onChange={handleCommonRoomPhotoChange}
              required
            />
            <button
              className="btn btn-dark mt-2"
              type="button"
              onClick={handleUploadCommonRoom}
            >
              Upload
            </button>

            {commonRoomUploadStatus && (
              <p className={`mt-2 ${status ? "text-success" : "text-danger"}`}>
                {commonRoomUploadStatus}
              </p>
            )}

            {error.common_room_photo && (
              <p className="text-danger mt-2">{error.common_room_photo}</p>
            )}
          </Form.Group>

          <Form.Group
            controlId="hostelPhotos"
            className="mb-3 text-black fw-bold text-start"
          >
            <Form.Label>Hostel Photos</Form.Label>
            <Form.Control
              type="file"
              multiple
              accept=".jpg, .jpeg, .png"
              onChange={handleHostelPhotoChange}
              required
            />
            <button
              className="btn btn-dark mt-2"
              type="button"
              onClick={handleUploadHostelPhoto}
            >
              Upload
            </button>

            {hostelUploadStatus && (
              <p className={`mt-2 ${status ? "text-success" : "text-danger"}`}>
                {hostelUploadStatus}
              </p>
            )}

            {error.hostel_photo && (
              <p className="text-danger mt-2">{error.hostel_photo}</p>
            )}
          </Form.Group>

          <div className="container">
            <div className="row">
              <div className="col">
                <button
                  className="btn btn-danger mt-3"
                  onClick={handleFinalSubmit}
                  type="button"
                >
                  {btnLoading ? "Submitting..." : "Submit"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {!preview && (
        <Form className="text-start text-black mt-5" onSubmit={handleSubmit}>
          <PaymentStatusModal
            msg={msg}
            show={show}
            isSuccess={isSuccess}
            onClose={() => setShow(false)}
            title={title}
            btnTitle={btnTitle}
          />
          <div className="text-center mb-4">
            <h4 className="fw-bold mb-3" style={{ color: "#760B0B", fontSize: "28px" }}>
              REGISTER NEW HOSTEL
            </h4>
          </div>
          <div className="mt-2 mb-5 d-flex col-12 justify-content-evenly progress-container fw-bold">
            {steps.map((step, i) => {
              return (
                <div
                  key={i}
                  className="progress d-inline-block flex-grow-1 align-items-center d-flex justify-content-center align-items-center py-3"
                  style={{
                    borderBottom:
                      currentStep === i
                        ? "4px solid #28a745"
                        : currentStep > i
                        ? "4px solid #28a745"
                        : "4px solid #e0e0e0",
                    opacity: currentStep >= i ? 1 : 0.5,
                    color: currentStep >= i ? "#28a745" : "#999",
                    fontWeight: currentStep === i ? "700" : "500",
                    transition: "all 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    if (currentStep >= i) {
                      e.target.style.transform = "translateY(-2px)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  {step}
                </div>
              );
            })}
          </div>
          {currentStep === 0 && (
            <div className="container custom-highlight p-4" style={{ borderRadius: "15px" }}>
              <Form.Group
                className="mb-4"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label className="fw-semibold mb-2" style={{ color: "#333" }}>Name</Form.Label>
                <Form.Control
                  type="name"
                  value={formData.name}
                  onChange={(event) =>
                    setFormData((prev) => ({
                      ...prev,
                      name: event.target.value,
                    }))
                  }
                  className="py-2"
                  style={{
                    borderRadius: "10px",
                    border: "2px solid #e0e0e0",
                    transition: "border-color 0.3s ease",
                  }}
                  onFocus={(e) => e.target.style.borderColor = "#8B0000"}
                  onBlur={(e) => e.target.style.borderColor = "#e0e0e0"}
                />
                {errors.name && <p className="text-danger mt-2">{errors.name}</p>}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="address"
                  value={formData.address}
                  onChange={(event) =>
                    setFormData((prev) => ({
                      ...prev,
                      address: event.target.value,
                    }))
                  }
                />
                {errors.address && (
                  <p className="error text-danger">{errors.address}</p>
                )}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Pincode</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Pincode"
                  value={formData.pincode}
                  onChange={(event) =>
                    setFormData((prev) => ({
                      ...prev,
                      pincode: event.target.value,
                    }))
                  }
                />
                {errors.pincode && (
                  <p className="text-danger">{errors.pincode}</p>
                )}
                {errors.name && <p className="text-danger">{errors.pincode}</p>}

                <Form.Group
                  className="mb-3 mt-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Gender</Form.Label>
                  <Form>
                    <Form.Check
                      inline
                      label="Male"
                      type="radio"
                      id="male"
                      name="options"
                      value="MALE"
                      checked={formData.gender === "MALE"}
                      onChange={(event) =>
                        setFormData((prev) => ({
                          ...prev,
                          gender: event.target.value,
                        }))
                      }
                    />

                    <Form.Check
                      inline
                      label="Female"
                      type="radio"
                      id="female"
                      name="options"
                      value="FEMALE"
                      checked={formData.gender === "FEMALE"}
                      onChange={(event) =>
                        setFormData((prev) => ({
                          ...prev,
                          gender: event.target.value,
                        }))
                      }
                    />

                    <Form.Check
                      inline
                      label="Unisex"
                      type="radio"
                      id="unisex"
                      name="options"
                      value="UNISEX"
                      checked={formData.gender === "UNISEX"}
                      onChange={(event) =>
                        setFormData((prev) => ({
                          ...prev,
                          gender: event.target.value,
                        }))
                      }
                    />
                  </Form>
                  {errors.name && (
                    <p className="text-danger">{errors.gender}</p>
                  )}
                </Form.Group>
                <Form.Group
                  className="mb-3 mt-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <Form.Label>Room type</Form.Label>
                  <Form>
                    <Form.Check
                      inline
                      label="Single"
                      type="checkbox"
                      id="single"
                      name="options"
                      value="SINGLE_BED"
                      checked={formData.room_type
                        .split(",")
                        .includes("SINGLE_BED")}
                      onChange={handleRoomType}
                    />

                    <Form.Check
                      inline
                      label="Double"
                      type="checkbox"
                      id="double"
                      name="options"
                      value="DOUBLE_BED"
                      checked={formData.room_type
                        .split(",")
                        .includes("DOUBLE_BED")}
                      onChange={handleRoomType}
                    />

                    <Form.Check
                      inline
                      label="Triple"
                      type="checkbox"
                      id="triple"
                      name="options"
                      value="TRIPLE_BED"
                      checked={formData.room_type
                        .split(",")
                        .includes("TRIPLE_BED")}
                      onChange={handleRoomType}
                    />
                  </Form>
                  {errors.room_type && (
                    <p className="text-danger">{errors.room_type}</p>
                  )}
                </Form.Group>
                <div className="container">
                  <div className="row">
                    <div className="col"></div>
                    <div className="col d-flex justify-content-end">
                      <button
                        className="btn btn-success mt-3 fw-semibold px-4 py-2"
                        type="button"
                        onClick={handleNext}
                        style={{
                          borderRadius: "10px",
                          transition: "all 0.3s ease",
                          boxShadow: "0 4px 15px rgba(40, 167, 69, 0.3)",
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = "translateY(-2px)";
                          e.target.style.boxShadow = "0 6px 20px rgba(40, 167, 69, 0.4)";
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = "translateY(0)";
                          e.target.style.boxShadow = "0 4px 15px rgba(40, 167, 69, 0.3)";
                        }}
                      >
                        Next →
                      </button>
                    </div>
                  </div>
                </div>
              </Form.Group>
            </div>
          )}
          {currentStep === 1 && (
            <div className="container custom-highlight">
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Food</Form.Label>
                <Form>
                  <Form.Check
                    inline
                    label="Vegeterian"
                    type="radio"
                    id="veg"
                    name="options"
                    value={"VEG"}
                    checked={formData.food === "VEG"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        food: event.target.value,
                      }))
                    }
                  />

                  <Form.Check
                    inline
                    label="Non Vegeterian "
                    type="radio"
                    id="nonveg"
                    name="options"
                    value={"NON VEG"}
                    checked={formData.food === "NON VEG"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        food: event.target.value,
                      }))
                    }
                  />
                </Form>
                {errors.food && <p className="text-danger">{errors.food}</p>}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Wifi</Form.Label>
                <Form>
                  <Form.Check
                    inline
                    label="Available"
                    type="radio"
                    id="available"
                    name="options"
                    value="AVAILABLE"
                    checked={formData.wifi === "AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        wifi: event.target.value,
                      }))
                    }
                  />

                  <Form.Check
                    inline
                    label="Not Available"
                    type="radio"
                    id="notavailable"
                    name="options"
                    value="NOT AVAILABLE"
                    checked={formData.wifi === "NOT AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        wifi: event.target.value,
                      }))
                    }
                  />
                </Form>
                {errors.wifi && <p className="text-danger">{errors.wifi}</p>}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>House Keeping</Form.Label>
                <Form>
                  <div>
                    <Form.Check
                      inline
                      label="Available"
                      type="radio"
                      id="houseoption1"
                      name="options"
                      value="AVAILABLE"
                      checked={formData.housekeeping === "AVAILABLE"}
                      onChange={(event) =>
                        setFormData((prev) => ({
                          ...prev,
                          housekeeping: event.target.value,
                        }))
                      }
                    />

                    <Form.Check
                      inline
                      label="Not Available"
                      type="radio"
                      id="houseoption2"
                      name="options"
                      value="NOT AVAILABLE"
                      checked={formData.housekeeping === "NOT AVAILABLE"}
                      onChange={(event) =>
                        setFormData((prev) => ({
                          ...prev,
                          housekeeping: event.target.value,
                        }))
                      }
                    />
                  </div>
                </Form>
                {errors.housekeeping && (
                  <p className="text-danger">{errors.housekeeping}</p>
                )}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Purified Water</Form.Label>
                <Form>
                  <Form.Check
                    inline
                    label="Available"
                    type="radio"
                    id="wateravailable"
                    name="options"
                    value="AVAILABLE"
                    checked={formData.purified_water === "AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        purified_water: event.target.value,
                      }))
                    }
                  />

                  <Form.Check
                    inline
                    label="Not Available"
                    type="radio"
                    id="waternotavailable"
                    name="options"
                    value="NOT AVAILABLE"
                    checked={formData.purified_water === "NOT AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        purified_water: event.target.value,
                      }))
                    }
                  />
                </Form>
                {errors.purified_water && (
                  <p className="text-danger">{errors.purified_water}</p>
                )}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Workout Zone</Form.Label>
                <Form>
                  <Form.Check
                    inline
                    label="Available"
                    type="radio"
                    id="workoutavailable"
                    name="options"
                    value="AVAILABLE"
                    checked={formData.workout_zone === "AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        workout_zone: event.target.value,
                      }))
                    }
                  />

                  <Form.Check
                    inline
                    label="Not Available"
                    type="radio"
                    id="workoutnotavailable"
                    name="options"
                    value="NOT AVAILABLE"
                    checked={formData.workout_zone === "NOT AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        workout_zone: event.target.value,
                      }))
                    }
                  />
                </Form>
                {errors.workout_zone && (
                  <p className="text-danger">{errors.workout_zone}</p>
                )}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Refrigerator</Form.Label>

                <Form>
                  <Form.Check
                    inline
                    label="Available"
                    type="radio"
                    id="refavailable"
                    name="options"
                    value="AVAILABLE"
                    checked={formData.refrigerator === "AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        refrigerator: event.target.value,
                      }))
                    }
                  />

                  <Form.Check
                    inline
                    label="Not Available"
                    type="radio"
                    id="refnotavailable"
                    name="options"
                    value="NOT AVAILABLE"
                    checked={formData.refrigerator === "NOT AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        refrigerator: event.target.value,
                      }))
                    }
                  />
                </Form>
                {errors.refrigerator && (
                  <p className="text-danger">{errors.refrigerator}</p>
                )}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Hot Water Supply</Form.Label>
                <Form>
                  <Form.Check
                    inline
                    label="Available"
                    type="radio"
                    id="hotwateravailable"
                    name="options"
                    value="AVAILABLE"
                    checked={formData.hot_water_supply === "AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        hot_water_supply: event.target.value,
                      }))
                    }
                  />

                  <Form.Check
                    inline
                    label="Not Available"
                    type="radio"
                    id="hotwaternotavailable"
                    name="options"
                    value="NOT AVAILABLE"
                    checked={formData.hot_water_supply === "NOT AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        hot_water_supply: event.target.value,
                      }))
                    }
                  />
                </Form>
                {errors.hot_water_supply && (
                  <p className="text-danger">{errors.hot_water_supply}</p>
                )}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Washroom</Form.Label>
                <Form>
                  <Form.Check
                    inline
                    label="Attach Washroom"
                    type="radio"
                    id="attachwashroom"
                    name="options"
                    value="ATTACHED"
                    checked={formData.washroom === "ATTACHED"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        washroom: event.target.value,
                      }))
                    }
                  />

                  <Form.Check
                    inline
                    label="Common Washroom"
                    type="radio"
                    id="commonwashroom"
                    name="options"
                    value="COMMON"
                    checked={formData.washroom === "COMMON"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        washroom: event.target.value,
                      }))
                    }
                  />
                </Form>
                {errors.washroom && (
                  <p className="text-danger">{errors.washroom}</p>
                )}

                <div className="container">
                  <div className="row">
                    <div className="col">
                      <button
                        className="btn btn-primary mt-3"
                        onClick={handleBack}
                        type="button"
                      >
                        Back
                      </button>
                    </div>
                    <div className="col d-flex justify-content-end">
                      <button
                        className="btn btn-success mt-3"
                        onClick={handleNext}
                        type="button"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </Form.Group>
            </div>
          )}
          {currentStep === 2 && (
            <>
              <div className="container custom-highlight">
                <Form.Group
                  className="mb-3"
                  controlId="exampleForm.ControlInput1"
                >
                  <MapComponent setPosition={setPosition} position={position} />
                  <div className="container">
                    <div className="row">
                      <div className="col">
                        <button
                          className="btn btn-primary mt-3"
                          onClick={handleBack}
                          type="button"
                        >
                          Back
                        </button>
                      </div>
                      <div className="col d-flex justify-content-end">
                        <button
                          className="btn btn-success mt-3"
                          onClick={handleNext}
                          type="button"
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </Form.Group>
              </div>
            </>
          )}
          {currentStep === 3 && (
            <div className="container custom-highlight">
              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Starting Price</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="price"
                  value={formData.starting_price}
                  onChange={(event) =>
                    setFormData((prev) => ({
                      ...prev,
                      starting_price: event.target.value,
                    }))
                  }
                />
                {errors.starting_price && (
                  <p className="text-danger">{errors.starting_price}</p>
                )}
              </Form.Group>

              <Form.Group
                className="mb-3"
                controlId="exampleForm.ControlInput1"
              >
                <Form.Label>Unit</Form.Label>
                <Form>
                  <Form.Check
                    inline
                    label="Available"
                    type="radio"
                    id="option1"
                    name="options"
                    value="AVAILABLE"
                    checked={formData.unit === "AVAILABLE"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        unit: event.target.value,
                      }))
                    }
                  />

                  <Form.Check
                    inline
                    label="Not Available"
                    type="radio"
                    id="option2"
                    name="options"
                    value="FILLED"
                    checked={formData.unit === "FILLED"}
                    onChange={(event) =>
                      setFormData((prev) => ({
                        ...prev,
                        unit: event.target.value,
                      }))
                    }
                  />
                </Form>
                {errors.unit && <p className="text-danger">{errors.unit}</p>}

                <div className="container">
                  <div className="row">
                    <div className="col">
                      <button
                        className="btn btn-primary mt-3"
                        onClick={handleBack}
                        type="button"
                      >
                        Back
                      </button>
                    </div>
                    <div className="col d-flex justify-content-end">
                      <button
                        className="btn btn-success mt-3"
                        onClick={handleNext}
                        type="button"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </Form.Group>
            </div>
          )}
          {currentStep === 4 && (
            <div className="container mt-1 text-black custom-highlight">
              <div className="text-center my-3">
                <h5 className="fs-5 fw-bold" style={{ color: "#760B0B" }}>
                  PREVIEW
                </h5>
              </div>
              <div className="row g-4 d-flex text-start">
                <h2 className="d-sm-none d-block">Basic Details</h2>
                <div className="col-4 d-none d-sm-block fs-3 fw-bold">
                  Basic Details
                </div>
                <div className="col-8 text-start">
                  <Row className="flex-grow-1">
                    <div className="col flex-grow-1">
                      <p>
                        <b>Name : </b>
                        <span>{formData.name}</span>
                      </p>
                    </div>
                    <div className="col flex-grow-1">
                      <p>
                        <b>Gender : </b>
                        <span>{formData.gender}</span>
                      </p>
                    </div>
                  </Row>
                  <Row>
                    <div className="col">
                      <p>
                        <b>Address : </b>
                        <span>{formData.address}</span>
                      </p>
                    </div>
                  </Row>
                  <Row>
                    <div className="col flex-grow-1">
                      <p>
                        <b>Pincode : </b>
                        <span>{formData.pincode}</span>
                      </p>
                    </div>
                    <div className="col flex-grow-1">
                      <p>
                        <b>Room Type : </b>
                        <span>{formData.room_type}</span>
                      </p>
                    </div>
                  </Row>
                </div>
              </div>
              <hr></hr>
              <div className="row g-4 text-start">
                <h2 className="d-sm-none d-block">Hostel Details</h2>
                <div className="col-4 d-none d-sm-block fs-3 fw-bold">
                  Hostel Details
                </div>
                <div className="col-8">
                  <Row>
                    <Col>
                      <Row className="text-start">
                        <p>
                          <b>Food : </b>
                          <span>{formData.food}</span>
                        </p>
                      </Row>
                      <Row className="text-start">
                        <p>
                          <b>Wifi : </b>
                          <span>{formData.wifi}</span>
                        </p>
                      </Row>
                      <Row className="text-start">
                        <p>
                          <b>House Keeping : </b>
                          <span>{formData.housekeeping}</span>
                        </p>
                      </Row>
                      <Row className="text-start">
                        <p>
                          <b>Purified Water : </b>
                          <span>{formData.purified_water}</span>
                        </p>
                      </Row>
                    </Col>
                    <Col>
                      <Row className="text-start">
                        <p>
                          <b>Workout Zone : </b>
                          <span>{formData.workout_zone}</span>
                        </p>
                      </Row>
                      <Row className="text-start">
                        <p>
                          <b>Refrigerator : </b>
                          <span>{formData.refrigerator}</span>
                        </p>
                      </Row>
                      <Row className="text-start">
                        <p>
                          <b>Hot Water Supply : </b>
                          <span>{formData.hot_water_supply}</span>
                        </p>
                      </Row>
                      <Row className="text-start">
                        <p>
                          <b>Washroom : </b>
                          <span>{formData.washroom}</span>
                        </p>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </div>
              <hr></hr>
              <div className="row g-4 text-start">
                <h2 className="d-sm-none d-block">Price</h2>
                <div className="col-4 d-none d-sm-block fs-3 fw-bold">
                  Price
                </div>
                <div className="col-8">
                  <Row>
                    <Col>
                      <p>
                        <b>Starting Price : </b>
                        <span>{formData.starting_price}</span>
                      </p>
                    </Col>
                    <Col>
                      <p>
                        <b>Unit : </b>
                        <span>{formData.unit}</span>
                      </p>
                    </Col>
                  </Row>
                </div>
              </div>
              <hr></hr>

              <Row>
                <Col>
                  <button className="btn btn-dark" onClick={handleEdit}>
                    Edit
                  </button>
                </Col>
                <Col className="d-flex justify-content-end">
                  <button className="btn btn-danger" onClick={handleSubmit}>
                    {btnLoading ? "Saving..." : "Save"}
                  </button>
                </Col>
              </Row>
            </div>
          )}
        </Form>
      )}
    </div>
  );
}
